export const URL_REG_EXP = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?%#\[\]@!\\$&'()*+,;=.]+$/;
export const LINK_REG_EXP = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/={}]*)/;
export const EMAIL_REG_EXP = /\S+@\S+\.\S+/;
export const PASS_CODE_REG_EXP = /^[0-9a-zA-Z!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]{6,63}$/;
export const HEX_COLOR_REG_EXP = /^#[0-9a-fA-F]{6}$/;
export const RGB_COLOR_REG_EXP =
    /^rgb\(\s*(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})\s*,\s*(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})\s*,\s*(25[0-5]|2[0-4]\d|1\d\d|\d{1,2})\s*\)$/i;
export const SUBDOMAIN_REG_EXP = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/gm;
export const EMAIL_VALIDATION_REG_EXP = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const BASE_EMAIL_VALIDATION_REG_EXP = /^\w+([-+.']\w+)*$/;
export const ALPHA_NUMERICAL_REG_EXP = /^[a-zA-Z0-9]*$/;
export const ONLY_SPACES_REG_EXP = /^\s+/g;
export const UNDERLINE_REG_EXP = /_/g;
export const SPACE_IN_BEGIN_REG_EXP = /^\s+/;
export const NEW_LINE_REG_EXP = /\n/;
export const DOMAIN_REG_EXP = /\w+([-.]\w+)*\.\w+([-.]\w+)*$/gm;
export const URL_WITH_PWD_REG_EXP = /\?pwd.+/g;
export const PHONE_REG_EXP = /[^\d\+]/g;
export const NOT_LETTER_REG_EXP = /\W/g;
export const NUMBERS_ONLY_REG_EXP = /^[0-9\b]+$/;
export const ALPHA_NUMERIC_REGEX_WITH_SPACES = /^\s*([0-9a-zA-Z ]*)\s*$/;
export const WITHOUT_SPACES_REGEX_EXP = / /g;
export const NUMERICAL_1_TO_999_EXP = /^(?:[1-9]|[1-9][0-9]{1,2})$/;
export const FILE_TYPE_REG_EXP = /[^\.]*$/;
export const HTML_TAGS_REG_EXP = /(&nbsp;|<([^>]+)>)/g;
export const DISPLAY_NAME_ERROR_REG_EXP = /[\[\]<>";:()]/g;
export const NEW_LINES_REG_EXP = /\n+/g;
export const PARAGRAPHS_REG_EXP = /<(?!\/?(h1|h2|h3|p|li)\b)[^>]+>/g;
export const PREFIX_HYPHEN_SPACE_REG_EXP = /^ - /;
export const CODE_BLOCK_REGEX = /(```[\s\S]*?```)/g;
export const DOMAIN_VALIDATION_REG_EXP = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63}(?<!-))*\.[A-Za-z]{2,63}$/;